<template>
  <div id="c-card">
    <div class="swiper-container" id="companySwiper">
      <div class="swiper-wrapper">
        <div class="swiper-slide">
          <!-- slides 1-->
          <div class="slide-box slide-box1">
            <div class="image" id="image1BG">
              <img :src="resourceUrl+companyInfo.ent_logo">
            </div>
            <div class="content" id="contentCard">
              <div class="title">{{companyInfo.ent_name}}</div>
              <div class="box" v-for="(value,index) in data1" :key="index">
                <div class="img">
                  <img :src="value.image">
                </div>
                <div class="info">
                  <span class="tip">{{value.tip}}</span>
                  <span class="value" v-show="index===0">{{companyInfo.ent_contacts}}</span>
                  <span class="value" v-show="index===1">{{companyInfo.tel}}</span>
                  <span class="value" v-show="index===2">{{companyInfo.phone}}</span>
                  <span class="value" v-show="index===3">{{companyInfo.email}}</span>
                  <div class="value value1" v-show="index===4">{{companyInfo.main_business}}</div>
                </div>
              </div>
            </div>
            <div class="slogan"><span>中消在线</span>&nbsp;&nbsp;生命安全<span>服务</span>平台</div>
          </div>
        </div>
        <!-- slides 2-->
        <div class="swiper-slide">
          <div class="slide-box slide-box2">
            <div class="title1">公司简介</div>
            <div class="title2">Company Profile</div>
            <img class="image" v-show="companyInfo.ent_des_img.length>0" :src="resourceUrl+companyInfo.ent_des_img">
            <div class="intro" id="contentInfo">
              <div class="value">{{companyInfo.ent_des}}</div>
            </div>
          </div>
        </div>
        <!-- slides 3-->
        <div class="swiper-slide" :hidden="companyInfo.tails.goodsList.length<=0">
          <div class="slide-box slide-box3">
            <div class="title1">产品展示</div>
            <div class="title2">Product</div>
            <div class="content">
              <div class="box" v-for="(value,index) in companyInfo.tails.goodsList" :key="index">
                <img :src="value.product_cover">
                <div class="title">{{value.product_name}}</div>
                <div class="money">电议</div>
<!--                <div class="money">￥ {{value.tails.discount_price}}</div>-->
              </div>
            </div>
          </div>
        </div>
        <!-- slides 4-->
        <div class="swiper-slide">
          <div class="slide-box slide-box4">
            <div class="title1">联系我们</div>
            <div class="title2">Contact</div>
            <div class="address">
              <div class="addressMap" id="addressMap"></div>
            </div>
            <div class="content">
              <div class="box" v-for="(value,index) in data2" :key="index">
                <div class="img">
                  <img :src="value.image">
                </div>
                <div class="info">
                  <span class="tip">{{value.tip}}</span>
                  <span class="value" v-show="index===0">{{companyInfo.ent_contacts}}</span>
                  <span class="value" v-show="index===1">{{companyInfo.tel}}</span>
                  <span class="value" v-show="index===2">{{companyInfo.phone}}</span>
                  <span class="value value1" v-show="index===3">{{businessUrl + companyInfo.tails.supplierId}}</span>
                  <!--   <span class="value value1" v-show="index===3"><a href="">{{businessUrl + companyInfo.tails.supplierId}}</a></span>-->
                  <div class="value value2" v-show="index===4">{{companyInfo.province+' '+companyInfo.city+' '+companyInfo.area+' '+companyInfo.address}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="swiper-arrow" v-show="currentIndex!==3" @click="nextClick">
        <span></span>
      </div>
    </div>
  </div>
</template>

<script>
import wxShare from '../wx/weixin.js'
// 高德地图
// import AMap from 'AMap'
import AMAP from '../map/map'
import Swiper from 'swiper'
export default {
  data () {
    return {
      businessID: 0,
      resourceUrl: this.resourceUrl,
      businessUrl: 'http://www.zxzx119.com/shopcompany/',
      data1: [
        {'image': require('../assets/icon-c-mine.png'), 'tip': '联系人：'},
        {'image': require('../assets/icon-c-phone.png'), 'tip': '电话：'},
        {'image': require('../assets/icon-c-mobile.png'), 'tip': '手机：'},
        {'image': require('../assets/icon-c-email.png'), 'tip': '邮箱：'},
        {'image': require('../assets/icon-c-carrer.png'), 'tip': '主营行业：'}
      ],
      data2: [
        {'image': require('../assets/icon-c-mine.png'), 'tip': '联系人：'},
        {'image': require('../assets/icon-c-phone.png'), 'tip': '电话：'},
        {'image': require('../assets/icon-c-mobile.png'), 'tip': '手机：'},
        {'image': require('../assets/icon-c-ip.png'), 'tip': '网址：'},
        {'image': require('../assets/icon-c-location.png'), 'tip': '地址：'}
      ],
      companyInfo: {
        'ent_contacts': '艾进',
        'ent_logo': '58675444043481088',
        'email': '4001919119@zxzx119.com',
        'ent_name': '上海中消网络科技有限公司',
        'tel': '400-1919-119',
        'phone': '1380-1919-119',
        'main_business': '消防物联网',
        'ent_des_img': '1173479570658033664',
        // 'ent_des_img': '',
        'ent_des': '2016年，中消在线总部正式于上海成立，是中国首家以“互联网+”思维模式打造的消防资源整合性综合服务平台。2017年，中消在线技术部于杭州成立，着力于中消平台、APP以及智慧消防等高新科技开发及研究。\n' +
          '未来，中消在线将以提高全民消防安全意识为己任，努力开拓社会消防公益产业服务领域，凝聚高新技术人才将人工智能技术融入中消APP应用及网络平台，竭力实现消防行业的信息化、科技化及智能化，引领消防进入大数据时代！',
        'template_id': '',
        'province': '上海市',
        'city': '上海市',
        'area': '黄浦区',
        'address': '淮海中路98号金钟广场33层',
        'tails': {
          'goodsList': [
            {'id': '', 'product_name': '消防设施******', 'product_cover': 'http://cdn.zxzx119.com/1166980268867715072'},
            {'id': '', 'product_name': '消防设施******', 'product_cover': 'http://cdn.zxzx119.com/1166980268867715072'},
            {'id': '', 'product_name': '消防设施******', 'product_cover': 'http://cdn.zxzx119.com/1166980268867715072'},
            {'id': '', 'product_name': '消防设施******', 'product_cover': 'http://cdn.zxzx119.com/1166980268867715072'},
            {'id': '', 'product_name': '消防设施******', 'product_cover': 'http://cdn.zxzx119.com/1166980268867715072'}
          ],
          'supplierId': ''
        }
      },
      map: '',
      latitude: '1',
      longitude: '1',
      haveAddress: 0,
      mySwiper: '',
      currentIndex: 0,
      startScroll: 0,
      touchStart: 0,
      touchCurrent: 0
    }
  },
  methods: {
    loadData: function () {
      var _this = this
      if (parseInt(this.businessID) !== 0) {
        // 企业信息
        // this.companyInfo.ent_des_img = ''
        this.utils.GET(this.companyUrl + '/entCard/detail?id=' + this.businessID, function (response) {
          _this.companyInfo = response.data
          _this.setView()
          _this.loadShareInfo()
        })
      } else {
        this.businessUrl = 'http://www.zxzx119.com'
        this.setView()
      }
      var winWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
      document.getElementById('image1BG').style.height = (86.0 * winWidth) / 75.0 + 'px'
      let height = (74.0 * winWidth) / 75.0
      document.getElementById('contentCard').style.top = height + 'px'
      var winHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
      let textHeight = parseInt((winHeight - 370) / 22) * 22
      document.getElementById('contentInfo').style.maxHeight = textHeight + 'px'
    },
    setView: function () {
      var _this = this
      setTimeout(function () {
        _this.initSwiper()
        _this.searchResult()
      }, 1000)
    },
    loadShareInfo: function () {
      var imgUrl = this.resourceUrl + this.companyInfo.ent_logo
      var title = this.companyInfo.tails.title
      var content = this.companyInfo.tails.content
      if (this.utils.isNull(title)) {
        title = this.companyInfo.ent_name
      }
      if (this.utils.isNull(content)) {
        content = this.companyInfo.main_business
      }
      console.log('share-----title--------' + title)
      console.log('share-----content--------' + content)
      console.log('share-----imgUrl--------' + imgUrl)
      wxShare.wxRegister(title, content, imgUrl)
    },
    searchResult: function () {
      var _this = this
      var city = this.companyInfo.city
      console.log('=======================' + city)
      var placeSearch = new AMap.PlaceSearch({
        // city 指定搜索所在城市，支持传入格式有：城市名、citycode和adcode
        city: city,
        citylimit: true
      })
      let address = this.companyInfo.address
      placeSearch.search(address, function (status, result) {
        console.log(status)
        console.log(result)
        if (status === 'no_data') {
          _this.resetLocation()
        } else {
          // 查询成功时，result即对应匹配的POI信息
          var info = result.poiList.pois[0]
          _this.latitude = info.location.lat
          _this.longitude = info.location.lng
          _this.haveAddress = 1
          _this.mapView()
        }
      })
    },
    resetLocation: function () {
      console.log('重新定位==========================')
      var _this = this
      var city = this.companyInfo.city
      var placeSearch = new AMap.PlaceSearch({
        // city 指定搜索所在城市，支持传入格式有：城市名、citycode和adcode
        city: city,
        citylimit: true
      })
      placeSearch.search(this.companyInfo.area, function (status, result) {
        console.log(status)
        console.log(result)
        // 查询成功时，result即对应匹配的POI信息
        var info = result.poiList.pois[0]
        _this.latitude = info.location.lat
        _this.longitude = info.location.lng
        _this.haveAddress = 1
        _this.mapView()
      })
    },
    mapView: function () {
      AMap.plugin(['AMap.ToolBar', 'AMap.Scale', 'AMap.PlaceSearch'], function () {
      })
      var _this = this
      if (this.haveAddress === 1) {
        console.log('000000====-----------' + _this.latitude)
        this.map = new AMap.Map('addressMap', {
          zoom: 16, // 级别
          center: [_this.longitude, _this.latitude], // 中心点坐标
          viewMode: '3D'// 使用3D视图
          // lang: 'en'
        })
        AMap.plugin(['AMap.ToolBar', 'AMap.Scale', 'AMap.PlaceSearch'], function () {
          _this.map.addControl(new AMap.ToolBar())
          _this.map.addControl(new AMap.Scale())
        })
        console.log('000000====-----------')
        var icon = new AMap.Icon({
          // 图标尺寸
          // size: new AMap.Size(25, 34),
          // 图标的取图地址
          image: '//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-red.png',
          // 图标所用图片大小
          imageSize: new AMap.Size(33, 44)
          // 图标取图偏移量
          // imageOffset: new AMap.Pixel(-9, -3)
        })
        var marker = new AMap.Marker({
          position: new AMap.LngLat(_this.longitude, _this.latitude),
          icon: icon
          // offset: new AMap.Pixel(-13, -30)
        })
        _this.map.add(marker)
      }
    },
    nextClick: function () {
      this.mySwiper.slideNext()
    },
    initSwiper: function () {
      var _this = this
      this.mySwiper = new Swiper('#companySwiper', {
        direction: 'vertical',
        on: {
          slideChangeTransitionEnd: function () {
            _this.currentIndex = _this.mySwiper.activeIndex
          }
        }
      })
      this.mySwiper.slides.on('slideChange', function (e) {
        console.log('000000000000')
        // console.log('====-----' + this.activeIndex)
        // _this.currentIndex = this.activeIndex
      })
      this.mySwiper.slides.on('touchstart', function (e) {
        _this.startScroll = this.scrollTop
        _this.touchStart = e.targetTouches[0].pageY
      }, true)
      this.mySwiper.slides.on('touchmove', function (e) {
        _this.touchCurrent = e.targetTouches[0].pageY
        var touchesDiff = _this.touchCurrent - _this.touchStart
        var slide = this
        var onlyScrolling =
          (slide.scrollHeight > slide.offsetHeight) &&
          (
            (touchesDiff < 0 && _this.startScroll === 0) ||
            (touchesDiff > 0 && _this.startScroll === (slide.scrollHeight - slide.offsetHeight)) ||
            (_this.startScroll > 0 && _this.startScroll < (slide.scrollHeight - slide.offsetHeight))
          )
        if (onlyScrolling) {
          e.stopPropagation()
        }
      }, true)
    }
  },
  mounted () {
    let cid = this.$route.query.cid
    this.businessID = cid
    // this.businessID = 26114
    console.log('1231232131241=======' + cid)
    var _this = this
    AMAP().then(function () {
      console.log('1231232131241=======' + cid)
      _this.loadData()
      _this.mapView()
    })
  }
}
</script>

<style scoped>
  .swiper-container {
    position: absolute;
    left: 0px;
    right: 0px;
    width: 100%;
    height: 100%;
  }
  .swiper-slide {
    background: #FFFFFF;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
  }
  .swiper-slide .slide-box {
    min-height: 100%;
    min-width: 100%;
  }
  .slide-box1 .image{
    width: 100%;
    height: 500px;
    background-image: url(../assets/icon-c-card.jpg);
    background-size: contain;
    background-position: top center;
    background-repeat: no-repeat;
  }
  .slide-box1 .image img{
    position: absolute;
    top: 15px;
    left: 15px;
    width: 66px;
    height: 66px;
    background-size: contain;
    background-position: center center;
  }
  .slide-box1 .content{
    position: absolute;
    width: 100%;
    height: 240px;
  }
  .slide-box1 .content .title{
    position: relative;
    top: 0px;
    margin-left: 15px;
    margin-right: 15px;
    height: 50px;
    line-height: 50px;
    font-size: 19px;
    font-weight: 500;
    color: #1B496B;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .slide-box1 .content .box{
    position: relative;
    top: 0px;
    margin-left: 15px;
    height: 32px;
    line-height: 32px;
    font-size: 13px;
    color: #1B496B;
    /*border: solid 1px red;*/
    /*box-sizing: border-box;*/
  }
  .slide-box1 .content .box .img{
    position: relative;
  }
  .slide-box1 .content .box .img img{
    height: auto;
    width: auto;
    max-height: 15px;
    max-width: 15px;
  }
  .slide-box1 .content .box .info{
    position: absolute;
    top: -2px;
    left: 25px;
    right: 10px;
    height: 32px;
    line-height: 32px;
  }
  .slide-box1 .content .box .info .value1{
    position: absolute;
    top: 6px;
    left: 65px;
    right: 0px;
    height: 32px;
    line-height: 20px;
    font-size: 13px;
    color: #1B496B;
  }
  .slide-box2,.slide-box3,.slide-box4{
    min-width: 800px;
    background-image: url(../assets/icon-c-bg.jpg);
    background-position: center;
    background-repeat: no-repeat;
    /*background-size: auto 100%;*/
    /*background-size: 100%;*/
    background-size: cover;
    /*background-clip: content-box;*/
    /*background-color: yellow;*/
    /*border: solid 1px red;*/
    overflow: hidden;
  }
  .slide-box .title1{
    position: absolute;
    width: 100%;
    top: 50px;
    height: 30px;
    line-height: 30px;
    font-size: 20px;
    font-weight: bold;
    color: #1B496B;
    text-align: center;
  }
  .slide-box .title2{
    position: absolute;
    width: 100%;
    top: 85px;
    height: 15px;
    line-height: 15px;
    font-size: 13px;
    /*font-weight: 500;*/
    color: #1B496B;
    text-align: center;
  }
  .slide-box2 .image{
    position: relative;
    left: 16px;
    right: 16px;
    top: 125px;
    width: calc(100% - 30px);
    height: 170px;
    /*object-fit: contain;*/
    object-fit: cover;
    /*object-fit: fill;*/
    background-color: #FFFFFF;
    border: solid #1B496B 1px;
    box-sizing: border-box;
    padding: 4px;
  }
  .slide-box2 .intro{
    position: relative;
    /*top:20px;*/
    margin-top: 130px;
    /*top: 315px;*/
    /*left: 16px;*/
    /*right: 16px;*/
    margin-left: 15px;
    margin-right: 15px;
    line-height: 22px;
    max-height: 240px;
    font-size: 13px;
    color: #1B496B;
    overflow: hidden;
    /*white-space: nowrap;*/
    /*text-overflow: ellipsis;*/
    /*background-color: yellow;*/
  }
  .slide-box2 .intro::after{
    content: '...';
    position: absolute;
    right: 0;
    bottom: 0;
    /*padding-left: 40px;*/
    /*background: -webkit-linear-gradient(left, transparent, #fff 55%);*/
    /*background: -o-linear-gradient(right, transparent, #fff 55%);*/
    /*background: -moz-linear-gradient(right, transparent, #fff 55%);*/
    /*background: linear-gradient(to right, transparent, #fff 55%);*/
  }
  .slide-box3 .content{
    position: absolute;
    top: 130px;
    left: 0px;
    width: 100%;
    height: 380px;
  }
  .slide-box3 .content .box{
    position: relative;
    margin-left: 15px;
    margin-right: 15px;
    margin-bottom: 8px;
    height: 66px;
    border: solid 1px #02013F;
    box-sizing: border-box;
  }
  .slide-box3 .content .box img{
    position: absolute;
    top: 6px;
    left: 5px;
    width: 50px;
    height: 50px;
  }
  .slide-box3 .content .box .title{
    position: absolute;
    top: 6px;
    left: 66px;
    height: 34px;
    line-height: 17px;
    font-size: 13px;
    color: #1B496B;
  }
  .slide-box3 .content .box .money{
    position: absolute;
    top: 40px;
    left: 66px;
    height: 15px;
    line-height: 15px;
    font-size: 13px;
    color: #c41335;
  }
  .slide-box4 .address{
    position: absolute;
    left: 15px;
    right: 15px;
    top: 130px;
    height: 170px;
    width: calc(100% - 30px);
    border: solid #1B496B 1px;
    box-sizing: border-box;
  }
  .slide-box4 .address .addressMap{
    position: absolute;
    left: 4px;
    right: 4px;
    top: 4px;
    height: 162px;
    width: calc(100% - 8px);
  }
  .amap-icon img{
    width: 25px;
    height: 34px;
  }
  .slide-box4 .content{
    position: absolute;
    top: 310px;
    width: 100%;
    height: 180px;
  }
  .slide-box4 .content .box{
    position: relative;
    top: 10px;
    margin-left: 15px;
    height: 32px;
    line-height: 32px;
    font-size: 13px;
    color: #1B496B;
  }
  .slide-box4 .content .box .img{
    position: relative;
  }
  .slide-box4 .content .box .img img{
    height: auto;
    width: auto;
    max-height: 15px;
    max-width: 15px;
  }
  .slide-box4 .content .box .info{
    position: absolute;
    top: -2px;
    left: 25px;
    right: 10px;
    height: 32px;
    line-height: 32px;
  }
  .slide-box4 .content .box .info .value1{
    position: absolute;
    top: 6px;
    left: 43px;
    right: 0px;
    height: 32px;
    line-height: 20px;
    font-size: 13px;
    color: #1B496B;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .slide-box4 .content .box .info .value2{
    position: absolute;
    top: 7px;
    left: 43px;
    right: 0px;
    height: 32px;
    line-height: 20px;
    font-size: 13px;
    color: #1B496B;
  }
  /*.slide-box4 .content .box .info .value1 {*/
    /*position: absolute;*/
    /*overflow: hidden;*/
    /*white-space: nowrap;*/
    /*text-overflow: ellipsis;*/
  /*}*/
  .slide-box4 a{
    color: #1B496B;
  }
  @-webkit-keyframes moveIconUp {
    0% {
      -webkit-transform: translateY(100%) scale(1.2, 1.2);
      opacity: 0.2
    }
    50% {
      -webkit-transform: translateY(0%) scale(0.8, 0.8);
      opacity: 1
    }
    100% {
      -webkit-transform: translateY(-100%) scale(0.4, 0.4);
      opacity: 0.2
    }
  }
  .swiper-arrow {
    position: absolute;
    width: 46px;
    height: 25px;
    z-index: 1;
    left: 50%;
    margin-left: -23px;
    bottom: 15px;
  }
  .swiper-arrow span {
    background: url(../assets/icon-c-arrow.jpg) no-repeat center bottom;
    background-size: contain;
    width: 46px;
    height: 25px;
    display: block;
    /*opacity: 0.3;*/
    -webkit-animation: moveIconUp 1.5s ease infinite;
    -moz-animation: moveIconUp 1.5s ease infinite;
    -o-animation: moveIconUp 1.5s ease infinite;
    animation: moveIconUp 1.5s ease infinite;
  }

  .slogan{
    position: absolute;
    height: 20px;
    z-index: 1;
    right: 10px;
    bottom: 10px;

    color: #1B496B;
    font-size: 13px;
  }
  .slogan span{
    color: #c41335;
    font-weight: 500;
  }
</style>



// WEBPACK FOOTER //
// src/view/c-card.vue